import { WeatherCamsWidgetLazy } from './weatherCamsWidgetLazy';

const props = [];

export const WeatherCamsWidgetDirective = reactDirective => reactDirective(WeatherCamsWidgetLazy, props);
WeatherCamsWidgetDirective.$inject = ['reactDirective'];

// eslint-disable-next-line no-undef
angular.module('WB.App').directive('weatherCamsWidget', WeatherCamsWidgetDirective);
